<template>
	<div>
		<slider page="home" />
		<AlertApp :showPopup="showAlert"></AlertApp>
		<!-- <services :images="home" :size="4" :time="250" :show_message="true"/> -->
	</div>
</template>


<script>
	// HELPERS
	import _GlobalHelper from '@/store/helpers/global'
	// COMPONENTS
	import Slider from '@/components/Slider/Index'
	import AlertApp from '@/components/Popup/AlertApp.vue'
	// import Services from '@/components/Services/Index'
	// VUEX
	import { mapMutations } from 'vuex'
	//JSON
	const home = require('~/assets/json/pages.home.json')
	
	export default {
		name: 'home',
		components: {
			Slider: Slider,
			AlertApp
			// Services: Services
		},
		data() {
			return {
				showAlert: false,
				home: home.es.info
			}
	},
	methods: {	
		openPopup() {
			this.showAlert = true;
		},
		getDevice() {
			let user_agent = navigator.userAgent || navigator.vendor || window.opera;
			let sys = navigator.platform;

			if (/windows phone/i.test(user_agent)) {
				return "Windows";
			} else if (/android/i.test(user_agent)) {
				return "Android";
			} else if (/iPad|iPhone|iPod/.test(user_agent) && !window.MSStream) {
				return "iOS";
			} else if (sys.indexOf("Win") == 0) {
				return "Windows";
			} else if (sys.indexOf("Mac") == 0) {
				return "Mac";
			} else if (sys.indexOf("X11") == 0 || sys.indexOf("Linux") == 0) {
				return "Linux";
			} else {
				return "none";
			}
		},
	},
	created() {
			const device = this.getDevice()
			if (device == 'iOS' || device == 'Android') {
				this.openPopup()
			}
			
			sessionStorage.removeItem('HostedCheckout_sessionId');
			sessionStorage.removeItem('HostedCheckout_merchantState');
			sessionStorage.removeItem('HostedCheckout_embedContainer');

			if (this.$cookies.get("code") != null) {
                this.$cookies.remove("code")
            }
		}
		
	}
</script>


<style>
	
</style>